import { Component, OnInit,Input,Output,EventEmitter  } from '@angular/core';

@Component({
  selector: 'app-gestiones-infopresolicitud',
  templateUrl: './gestiones-infopresolicitud.component.html',
  styleUrls: ['./gestiones-infopresolicitud.component.scss']
})
export class GestionesInfopresolicitudComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Output() selectParticipante = new EventEmitter<number>();
  @Input() gestionSeleccionada: any
  @Input() participante: any
  constructor() {
    let i = []
  }

  ngOnInit(): void {
  }
  selectedtab(tab) {
    this.selecttab.emit(tab)
  }
  selectedparticipante(item) {
    this.selectParticipante.emit(item)
  }
  setConsolidacionTotal() {
    let totalconsolicacion = 0
    if (this.gestionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionCreditoBT != null) {
      this.gestionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionCreditoBT.forEach(element => {
        if (element.consolida == "S") {
          totalconsolicacion+=Number(element.saldo)
        }
      })
    }
    if (this.gestionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionSirc != null) {
      this.gestionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionSirc.forEach(element => {
        if (element.consolida == "S") {
          totalconsolicacion+=Number(element.saldo)
        }
      });
    }
    if (this.gestionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionTarjetaBT != null) {
      this.gestionSeleccionada.participante[this.participante].consolidacionDeudas.consolidacionTarjetaBT.forEach(element => {
        if (element.consolida == "S") {
          totalconsolicacion+=Number(element.saldo)
        }
      })
    }
    return totalconsolicacion
  }
  getcuotamym() {
    return Number(this.gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.cuotaNuevoCreditoConSeguro-Number(this.gestionSeleccionada.ofertaComercialSeleccionada.ofertaComercialSeleccionada.bienestarMixAndMatchAhorroMensual))
  }
}
